import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralStyleMenuManagement = styled.div`
  width: 100%;
  height: 100%;
  .MuiTextField-root {
    margin-right: 1em;
  }
  .MuiIconButton-colorInherit {
    border-radius: 0px;
    margin-right: 0px;
    padding: 0px;
    height: 1.7em;
  }
  .MuiIcon-colorPrimary {
    color: ${({ theme }) => theme.primary.purple};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: none;
  }
  .MuiIcon-colorSecondary {
    color: ${({ theme }) => theme.text.primary};
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .MuiTabs-scroller.MuiTabs-fixed {
    overflow-x: auto !important;
  }
  .MuiTabs-scroller.MuiTabs-fixed::-webkit-scrollbar {
    height: 0.3em;
  }

  .MuiTabs-scroller.MuiTabs-fixed ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }

  .MuiTabs-scroller.MuiTabs-fixed ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const useStylesMenuManagement = makeStyles(() => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.neutral.white,
  },
}));
